import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessage, faTimes } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { AlertCommentType } from '../../../utility/types/AlertCommentType';
import { getCommentBody, getCommenterName } from '../../../utility/conversationUtility';

function Comment({
  isActiveUser,
  isSystem,
  firstName,
  lastName,
  text,
  commentedAt,
  type,
  handleOpenDeleteModal,
  userCanDelete,
}) {
  const body = getCommentBody(text, type);
  const commenterName = getCommenterName(firstName, lastName, type);
  return (
    <div
      className={`${isActiveUser ? 'ml-auto' : 'mr-auto'}`}
      style={{ padding: '1rem' }}
    >
      <div className="align-self-end">
        {
            isActiveUser
              ? (
                <div className="text-right text-nowrap">
                  <small className="text-right text-secondary">
                    <i>{commentedAt}</i>
                  </small>
                </div>
              )
              : (
                <div className="text-nowrap">
                  <span className={`${isSystem ? 'text-danger' : ''}`}>
                    <FontAwesomeIcon icon={faMessage} className="mr-2" />
                    <b>{commenterName}</b>
                  </span>
                  <small className="text-right text-secondary ml-2">
                    <i>{commentedAt}</i>
                  </small>
                </div>
              )
          }
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: isActiveUser ? 'flex-end' : 'flex-start',
        }}
        >
          {(isActiveUser && type !== AlertCommentType.DELETED && userCanDelete) && (
            <div className="text-secondary p-1">
              <button type="button" onClick={handleOpenDeleteModal} className="btn btn-sm">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          )}
          <div
            style={{
              marginTop: 4,
              marginBottom: 4,
              marginLeft: isActiveUser ? 0 : '1.5rem',
              backgroundColor: isActiveUser ? '#fff' : '#DDDDDD',
              borderRadius: 16,
              padding: '0.5rem',
              wordWrap: 'break-word',
              maxWidth: '28rem',
              flexBasis: 0,
              minWidth: 'fit-content',
            }}
            className="border border-secondary"
          >
            <p className="mb-0">{body}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

Comment.propTypes = {
  isActiveUser: PropTypes.bool.isRequired,
  isSystem: PropTypes.bool.isRequired,
  type: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  commentedAt: PropTypes.string.isRequired,
  handleOpenDeleteModal: PropTypes.func.isRequired,
  userCanDelete: PropTypes.bool.isRequired,
};

export default Comment;
